import ResultEventModel from "../../models/modus/ResultEventModel";
import ModusServiceCollection from "../ModusServiceCollection";
import ResultEventSampleCollection from "./ResultEventSampleCollection";

/**
 * Result collection
 */
export default class ResultEventCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultEventModel;
  }

  getLaboratoryClient() {
    if (this.length) {
      let model = this.first();
      if (model) {
        return model.getLaboratoryClient();
      }
    }
    return null;
  }

  getResultEventSamples() {
    let collection = new ResultEventSampleCollection();
    if (this.length) {
      this.each((event) => {
        let samples = event.getResultEventSamples();
        if(samples && samples.count()) {
          samples.each((sample) => {
            collection.add(sample);
          });
        }
      });
    }
    return collection;
  }

  getLaboratoryTestPackages() {
    let samples = this.getResultEventSamples();
    return samples.getLaboratoryTestPackages();
  }

}
